// extracted by mini-css-extract-plugin
module.exports =  {"skeleton":"Step-Skeleton-module__skeleton___LBKad","skeleton_vertical":"Step-Skeleton-module__skeleton_vertical___Xw2DP"};